














































































import Vue from 'vue';
import { Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { mdiChevronRight } from '@mdi/js';
import { RegimeCaisse } from '@/store/regimeCaisse/types';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { Patient } from '@/store/patient/types';
import { deconnexionPatient } from '@/services/api/deconnexionPatient/api';
import Panel from '@/components/global/P2/Panel/Panel.vue';

const Props = Vue.extend({
	props: {
		sticky: {
			type: Boolean,
			default: false
		}
	}
});

@Component({
	components: { Panel }
})
export default class SubHeader extends Props {
	@Getter('infosPSBEN/getInfosPSBEN') getInfosPSBEN!: InfosPSBEN;
	@Getter('regimeCaisse/getRegimeCaisse') getRegimeCaisse!: RegimeCaisse;
	@Getter('patient/getPatient') getPatient!: Patient;

	chevronRight = mdiChevronRight;

	get hasLibelleCaisse(): boolean {
		return !!this.getRegimeCaisse.libelleCaisse;
	}

	get hasLibelleRegime(): boolean {
		return !!this.getRegimeCaisse.libelleRegime;
	}

	get nomUsageDifferentFamille(): boolean {
		return this.getInfosPSBEN.infosASSURE.nomUsage !== this.getInfosPSBEN.infosASSURE.nomFamille;
	}

	// Appel l'api IDPA pour déconnecter le patient identifier
	async vidagePatient() {
		await deconnexionPatient();
	}

	// Récupère le cookie ep-origin
	get urlRetourEP(): string {
		return this.$cookies.get('ep-origin');
	}

	// Redirige vers la npa ou l'ancien portail avec le vidage patient
	goToEP() {
		const cookieEpOrigin = this.$cookies.get('ep-origin');
		if (!this.$cookies.get('npa') && cookieEpOrigin?.includes('/PortailPS/')) {
			// si ancien portail
			window.location.href = cookieEpOrigin + '?_nfpb=true&c8_contextepatient_portletactionEvt=retourLoginNir&c8_contextepatient_portletselectionBenef=false';
		} else {
			// si npa : appel deconnexion patient et redirection
			// this.vidagePatient();
			window.location.href = cookieEpOrigin;
		}
	}
}
